/**
 * The store list's keyword, status filter, page and sort, kept in the URL query so browser Back
 * from a store's full-page view (e.g. /stores/:id/backup) lands on the same filtered list.
 * sort/dir/page reach the API query string unencoded, so only known values are accepted. A status
 * the dropdown no longer offers (a bookmark from before PDECOM-6293) falls back to every status,
 * rather than filtering the list by a value the select cannot show or clear.
 */
import { isFilterable } from './filterStatuses';

const SORT_DIRS = ['ASC', 'DESC'];

export const stateFromQuery = (search, sortCodes) => {
  const params = new URLSearchParams(search);
  const q = params.get('q');
  const page = parseInt(params.get('page'), 10);
  const sort = params.get('sort');
  const dir = params.get('dir');
  const status = params.get('status');
  return {
    search: q ? { fuzzyString: q } : null,
    statusType: isFilterable(status) ? status : '',
    pagination: {
      page: page >= 0 ? page : undefined,
      size: undefined,
      sort: sortCodes.includes(sort) ? sort : undefined,
      sortDir: SORT_DIRS.includes(dir) ? dir : undefined,
    },
  };
};

export const queryFromState = ({ search, statusType, pagination }) => {
  const params = new URLSearchParams();
  if (search && search.fuzzyString) {
    params.set('q', search.fuzzyString);
  }
  if (statusType) {
    params.set('status', statusType);
  }
  if (pagination.page) {
    params.set('page', pagination.page);
  }
  if (pagination.sort) {
    params.set('sort', pagination.sort);
  }
  if (pagination.sortDir) {
    params.set('dir', pagination.sortDir);
  }
  const query = params.toString();
  return query ? `?${query}` : '';
};
